import React, { useEffect } from "react";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import "./styles.scss";
import { setLanguage } from "../../redux/ui/action";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { updatePrefsRequest } from "../../redux/prefs/prefsSlice";
import { SUPPORTED_LOCALES, LOCALE_LABELS } from '../../constants/locales';

const LanguageSwitch = ({ dispatch, /*lng*/ }) => {
  const { t, i18n } = useTranslation(); // eslint-disable-line
  const prefs = useSelector((state) => state.prefs);

  const changeLanguage = (event) => {
    // dispatch(setLanguage(event.target.value));
    i18n.changeLanguage(event.target.value);
    dispatch(updatePrefsRequest({ lang: event.target.value, langManuallySet: true }));

    // persisting lang in url is done in Header (parent component)
  };

  const lng = i18n.language;
  // moved some setup logic to App.js (for cases where the header+lang switcher is missing such as the widget)


  return (
    <ButtonGroup toggle className="language-switch-group">
      <Helmet>
        <html lang={lng}></html>
      </Helmet>
      {SUPPORTED_LOCALES.map(locale => (
        <ToggleButton
          key={locale}
          type="radio"
          name="language"
          value={locale}
          checked={lng === locale}
          onChange={changeLanguage}
          variant="outline-dark"
        >
          <span className="d-none">{LOCALE_LABELS[locale]?.slice(0,2) || locale.slice(0,2)}</span>
          <span className="d-inline">{LOCALE_LABELS[locale] || locale}</span>
        </ToggleButton>
      ))}
    </ButtonGroup>
  );
};

const mapStateToProps = ({ vendors, results, ui }) => ({
  // lng: ui.language,
});

export default connect(mapStateToProps)(LanguageSwitch);
